<template>
  <div id="app">
    <router-view />
    <vue-progress-bar />
  </div>
</template>

<script>
export default {
  name: 'App',
  methods: {
    checkUserHasLoadpanding () {
      this.$axios.post(this.$base_api + '/api/v1/frontend/borrow/check-account-has-loan-pending')
        .then((response) => {
          if (response.data.code === 1) {
            this.has_pending_loan = response.data.data.has_pending_loan
            this.$store.dispatch('checkUserHasPendingLoan', this.has_pending_loan)
          }
        })
    }
  },
  created () {
    this.$Progress.start()
  },
  mounted () {
    this.$axios.defaults.headers.common['X-localization'] = this.$i18n.locale
    this.$Progress.finish()
    this.$nextTick(() => {
      if (localStorage.getItem('token') && localStorage.getItem('token') !== undefined) {
        this.checkUserHasLoadpanding()
        this.$store.dispatch('checkUserLogin', true)
        this.$store.dispatch('setDataBorrower', JSON.parse(localStorage.getItem('user')))
        if (localStorage.hasOwnProperty('borrower')) {
          const user = JSON.parse(localStorage.getItem('borrower')).user
          if (user) {
            this.$store.dispatch('setAvatar', user.avatar)
          }
        }
      }
    })
  }
}
</script>

<style>
@import "assets/styles/font.css";
@import "assets/styles/color.css";
@import "assets/styles/dimen.css";
@import "assets/styles/style.css";
</style>
